"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatInt = exports.FormatFloat = void 0;
function FormatFloat(value) {
    const str = typeof value !== "string" ? value.toString() : value;
    const strSplit = str.split(".");
    if (strSplit.length < 1) {
        return "0";
    }
    const main = strSplit[0];
    return FormatInt(main);
}
exports.FormatFloat = FormatFloat;
function FormatInt(value) {
    const str = typeof value !== "string" ? value.toString() : value;
    if (str.length <= 3) {
        return str;
    }
    return FormatInt(str.substr(0, str.length - 3)) + " " + str.substr(-3, 3);
}
exports.FormatInt = FormatInt;
//# sourceMappingURL=NumberFormat.js.map